<template>
  <!-- маршрут один на все карточки: ключ по slug пересоздаёт страницу целиком, и данные не подменяются «на месте» -->
  <Card :key="slug" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

import Card from './Card.vue';

const route = useRoute();
const slug = computed(() => String(route.params.slug ?? ''));

// переход на соседнюю карточку не сбрасывает прокрутку сам
watch(slug, (value) => {
  if (value) {
    window.scrollTo(0, 0);
  }
});
</script>
